import axios from 'axios'
import router from '@/router'

// 用于控制登录状态的变量
let isRedirecting = false;

// 创建 axios 实例
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // 可根据环境变量配置
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'multipart/form-data'
  }
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 可在此处统一添加 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  response => {
    if (response.data.code === 401) {
      // 未登录或登录过期，避免多次重定向
      if (!isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem('token');
        
        // 使用 setTimeout 延迟重定向，避免多个请求同时触发
        setTimeout(() => {
          router.push('/login').finally(() => {
            // 重定向完成后，重置状态
            setTimeout(() => {
              isRedirecting = false;
            }, 300);
          });
        }, 100);
      }
    }
    // 统一处理响应数据
    return response.data
  },
  error => {
    // 统一处理错误
    if (error.response && error.response.status === 401) {
      // 未登录或登录过期，避免多次重定向
      if (!isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem('token');
        
        // 使用 setTimeout 延迟重定向，避免多个请求同时触发
        setTimeout(() => {
          router.push('/login').finally(() => {
            // 重定向完成后，重置状态
            setTimeout(() => {
              isRedirecting = false;
            }, 300);
          });
        }, 100);
      }
    }
    return Promise.reject(error)
  }
)

// 封装 get 方法
http.getRequest = function(url, params = {}, config = {}) {
  return http.get(url, {
    params,
    ...config
  })
}

// 封装 post 方法
http.postRequest = function(url, data = {}, config = {}) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return http.post(url, formData, config)
}

export default http